<template>
  <div class="layout-navbars-container">
    <div class="layout-navbars-top" :class="`layout-navbars-top--${layout}`">
      <layout-logo v-if="showTopLogo" class="layout-navbars-logo" />
      <!-- 对齐 EB：Breadcrumb 组件始终挂载（折叠图标在 defaults/columns）；经典/横向仅隐藏面包屑文字 -->
      <breadcrumb-bar v-if="showTopBreadcrumbBar" class="layout-navbars-breadcrumb-wrap" />
      <classic-top-aside v-if="isClassicLayout" class="layout-navbars-menu-slot" />
      <horizontal-nav v-if="isTransverseLayout" class="layout-navbars-menu-slot" />
      <user-bar class="layout-navbars-user-wrap" />
    </div>
    <tags-view v-if="showTagsView" :class="themeStore.themeConfig.tagsStyle" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import useCrmebThemeConfigStore from '@/store/modules/themeConfig';
import TagsView from '@/layout/navBars/tagsView/index.vue';
import ClassicTopAside from '../component/ClassicTopAside.vue';
import HorizontalNav from '../navMenu/Horizontal.vue';
import LayoutLogo from '../logo/index.vue';
import BreadcrumbBar from './BreadcrumbBar.vue';
import UserBar from './UserBar.vue';

const themeStore = useCrmebThemeConfigStore();

const layout = computed(() => themeStore.themeConfig.layout);

const isClassicLayout = computed(() => layout.value === 'classic');
const isTransverseLayout = computed(() => layout.value === 'transverse');

const showTopLogo = computed(() => {
  const { isShowLogo } = themeStore.themeConfig;
  return isShowLogo && (isClassicLayout.value || isTransverseLayout.value);
});

/** defaults/columns 始终显示（含移动端折叠图标）；经典/横向不挂此栏 */
const showTopBreadcrumbBar = computed(() => {
  return layout.value !== 'classic' && layout.value !== 'transverse';
});

/** 经典布局 Tags 在 main/classic 内；顶栏仅 defaults/columns/transverse 显示 */
const showTagsView = computed(() => {
  const { isTagsview } = themeStore.themeConfig;
  return layout.value !== 'classic' && isTagsview;
});
</script>

<style scoped lang="scss">
/* 对齐 EB layout/navBars/breadcrumb/index.vue */
.layout-navbars-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  background: var(--prev-bg-topBar);
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
}
.layout-navbars-top {
  display: flex;
  align-items: center;
  width: 100%;
  height: 50px;
  min-width: 0;
  overflow: hidden;
  background: var(--prev-bg-topBar);
  border-bottom: 1px solid var(--prev-border-color-lighter, #ebeef5);
}
.layout-navbars-logo {
  flex-shrink: 0;
  padding: 0 8px;
}
/* 占满用户区左侧剩余宽度；压窄后 EP float 面包屑按层级换行 */
.layout-navbars-breadcrumb-wrap {
  flex: 0 0 auto;
  min-width: 0;
  overflow: hidden;
  height: 100%;
}
.layout-navbars-top--classic,
.layout-navbars-top--transverse {
  .layout-navbars-menu-slot {
    flex: 1;
    min-width: 0;
    overflow: hidden;
  }
  .layout-navbars-user-wrap {
    margin-left: 0;
  }
}
.layout-navbars-menu-slot {
  flex: 1;
  min-width: 0;
  overflow: hidden;
}
/* 对齐 EB layoutUserFlexNum=1：右侧吃剩余宽度，商家名在 UserBar 内随宽连续裁切 */
.layout-navbars-user-wrap {
  min-width: 0;
  margin-left: auto;
  overflow: hidden;
}
</style>
